import { createClient } from '@supabase/supabase-js'

// Project credentials from Supabase
const SUPABASE_URL = 'https://ejkamdcdpakcrhjdbfum.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVqa2FtZGNkcGFrY3JoamRiZnVtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ3NTA0OTIsImV4cCI6MjA3MDMyNjQ5Mn0.6nCcQE84s6BNhbSR6_Z3GPu9H_x1KtrNWQsxQooQ7RM'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;